import {useEffect} from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const LogoutPage = () => {
  const navigate = useNavigate();
  cookies.remove("authorization", { path: "/" });
  useEffect(() => {
    navigate("/")
  }, [navigate])
  return '';
};

export default LogoutPage;
